<template>
  <div class="k-audio">
    <p style="line-height:8">course-audio</p>
  </div>
</template>

<script>
  export default {
    name: 'k-audio',
    props: ['url'],
    computed: {

    },
    methods: {
      
    },
    created() {

    }
  }

</script>
